"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = require("../state");
let state = {
    getState: state_1.getState,
    setState: state_1.setState,
};
const clientApi = {
    module: async (name) => {
        return new Promise((resolve, reject) => {
            const synth = window["synth"];
            synth.loadScript(`/api/modules/${name}`).then(() => {
                resolve(synth.module(name));
            });
        });
    },
    ext: async (name, module) => {
        const synth = self["synth"];
        if (synth)
            await synth.loadScript(`/api/ext/${name}`, module);
    },
    assets: (path) => {
        if (!path)
            return fetch("/api/assets")
                .then(res => res.json())
                .then(console.log);
        return fetch("/api/assets", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ path }),
        })
            .then(res => res.text())
            .then(() => clientApi.assets());
    },
    asset: (name) => {
        return fetch(`/api/assets/${name}`);
    },
    store: (key) => {
        if (!key) {
            console.warn("no key");
            return;
        }
        let internalState = {
            getState: () => ({ editor: "" }),
            setState: (newState) => { },
        };
        if (typeof state !== "undefined")
            internalState = state;
        const code = (internalState.getState().editor || "").replace(`api.store(\'${key}\')`, ``).trim();
        const canvas = document.querySelector("canvas");
        const thumb = canvas.toDataURL("image/png", 0.5);
        return fetch("/api/store", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ key, code, thumb }),
        })
            .then(res => res.text())
            .then(console.log);
    },
    load: (key, apply = true) => {
        console.log("load", key, apply);
        if (!key) {
            console.warn("no key");
            return;
        }
        let internalState = {
            getState: () => ({ editor: "" }),
            setState: (newState) => { },
        };
        if (typeof state !== "undefined")
            internalState = state;
        console.log(`/api/store/${key}`, { state, internalState });
        return fetch(`/api/store/${key}`)
            .then(res => res.json())
            .then(data => {
            const { code, image } = data;
            console.log({ code, image });
            let oldCode = internalState.getState().editor;
            const newCode = oldCode.replace(`api.load(\'${key}\')`, code.trim()).trim();
            console.log({ newCode });
            if (apply)
                internalState.setState({ editor: newCode });
            return newCode;
        })
            .catch(err => {
            console.error("Error loading code:", err);
        });
    },
};
exports.default = clientApi;
